<template>
    <Paper class="company-prefix-index">
        <PrefixSearch @closeChange="searchCodes" :searchBlock='searchBlock' class="prefix-config-search" ref="search"></PrefixSearch>
        <div class="company-table">
            <prefixTable :tableData="tableData"></prefixTable>
        </div>
        <div class="company-prefix-add">
            <el-button @click="newCode" icon="el-icon-plus" type="primary" size="mini" class="new-button">
                {{$translate('lang.E3202102260005', { defaultText: '新增' })}}
            </el-button>
        </div>
        <pageList v-if="pageState" :pageMenu="pageMenu" @changeCurrent="currentDom" @changeSize="sizeDom" class="prefix-config-page"></pageList>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import PrefixSearch from './prefixSearch';
import prefixTable from './table';
import pageList from '../../../components/systemComponent/pageList';
import { CompanyPage } from '../../../api/systemManagementApi';
export default {
    name: 'companyPrefix',
    data() {
        return {
            pageState: true,
            searchBlock: false,
            pageMenu: {
                totalCount: 0,
                currentPage: 1,
                pageNo: 1, // 初始页
                pageSize: 10, // 每页个数
                pageSizes: [10, 20, 30, 40]
            },
            tableData: []
        };
    },
    methods: {
        searchCodes() {
            this.pageState = false;
            this.pageMenu.pageNo = 1;
            this.searchBlock = true;
            this.searchCode();
            this.$nextTick(() => {
                this.pageState = true;
            });
        },
        // 查询
        searchCode() {
            CompanyPage({
                prefixCode: this.$refs.search.queries.prefixCode,
                cnName: this.$refs.search.queries.cnName,
                registerStatus: this.$refs.search.queries.registerStatus,
                pageNo: this.pageMenu.pageNo,
                pageSize: this.pageMenu.pageSize
            }).then(res => {
                if (+res.code === 0) {
                    this.tableData = res.data.list;
                    this.pageMenu.totalCount = res.data.totalCount;
                }
                this.searchBlock = false;
            }).catch(() => {
                this.searchBlock = false;
            });
        },
        // 新增跳转
        newCode() {
            this.$router.push({
                path: '/newPrefix'
            });
        },
        // 分页1
        sizeDom(val) {
            this.pageMenu.pageSize = val;
            this.searchCode();
        },
        // 分页2
        currentDom(val) {
            this.pageMenu.pageNo = val;
            this.searchCode();
        }
    },
    components: {
        Paper,
        PrefixSearch,
        prefixTable,
        pageList
    },
    mounted() {
        this.searchCode();
    },
    activated() {
        this.searchCode();
    }
};
</script>
<style lang="less">
.company-prefix-index{
    .company-table{
        .el-table {
        height: calc(100vh - 180px) !important;
    }
    .row-bg {
        margin-top: 20px;
    }
    }
    .company-prefix-add{
        float: left;
        margin-top: 20px;
    }
    .prefix-config-page{
        margin-top: 20px;
        text-align: right;
    }
}
</style>